export const tealiumConfigSelector = state => state?.config?.data?.global?.tealiumConfig;
export const googleAnalyticsConfigSelector = state => state?.config?.data?.global?.googleAnalyticsConfig;
export const analyticsSelector = state => state?.config?.analytics;



